import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import Chip from '../../Chip/Chip';
import { ChipsWrapper } from './SpaceSettings.styled';
import Separator from './Separator';

const updateDocumentTitle = (currentSpaceName, tabDocumentTitlePrefix) => {
  const space = currentSpaceName ? `${currentSpaceName} - ` : '';
  document.title = `${tabDocumentTitlePrefix} - ${space}Aula`;
};

const SpaceSettingsTabPanel = React.memo(
  ({ tabs, currentTabId, currentSpaceName, onTabChange, spaceId }) => {
    const tabIndex = tabs.findIndex((tab) => tab.id === currentTabId);
    const CurrentTab = tabs[tabIndex].content;
    const tabDocumentTitlePrefix = tabs[tabIndex].documentTitlePrefix;

    const onChipClick = (clickedChip) => () => {
      const clickedChipIndex = tabs.findIndex(
        (tab) => tab.id === clickedChip.id
      );
      onTabChange(tabs, clickedChipIndex, spaceId);
    };

    useEffect(() => {
      updateDocumentTitle(currentSpaceName, tabDocumentTitlePrefix);
    }, [currentSpaceName, tabDocumentTitlePrefix]);

    return (
      <React.Fragment>
        <ChipsWrapper id="space-settings-tabs">
          {tabs.map((tab) => (
            <Chip
              key={tab.id}
              id={tab.id}
              title={tab.documentTitlePrefix}
              checked={tab.id === currentTabId}
              onChange={onChipClick(tab)}
            />
          ))}
        </ChipsWrapper>
        <Separator height="5px" />
        <CurrentTab />
      </React.Fragment>
    );
  }
);

SpaceSettingsTabPanel.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      content: PropTypes.func.isRequired,
      label: PropTypes.node.isRequired,
      documentTitlePrefix: PropTypes.string.isRequired,
    })
  ).isRequired,
  currentTabId: PropTypes.string.isRequired,
  onTabChange: PropTypes.func.isRequired,
  currentSpaceName: PropTypes.string,
  spaceId: PropTypes.string.isRequired,
};

SpaceSettingsTabPanel.defaultProps = {
  currentSpaceName: '',
};

export default SpaceSettingsTabPanel;
